<template>
  <div class="makeSureTheOrder">
    <div class="information" @click="toShippingAddress()">
      <img
        src="../../assets/img/icon_address@2x.png"
        alt=""
        style="width: 0.09rem; height: 0.12rem"
      />
      <div class="peopleInformation">
        <p class="address">
          {{
            address.province
              ? address.province + address.city + address.area + address.add
              : "--"
          }}
        </p>
        <p class="phoneAndName">
          {{ address.phone ? address.phone + " " + address.name : "- -" }}
        </p>
      </div>
      <img
        src="../../assets/img/btn_more@2x.png"
        alt=""
        style="width: 0.06rem; height: 0.09rem"
      />
    </div>
    <!-- 购买的商品信息 -->
    <div class="commodity">
      <h2>全部商品</h2>
      <div class="commodityInformation">
        <img
          :src="
            orderParams.commodityDetail.pic
              ? orderParams.commodityDetail.pic
              : ''
          "
          alt=""
          style="width: 0.88rem; height: 0.88rem"
        />
        <div class="commodityInformation_right">
          <div class="commodity_name">
            {{
              orderParams.commodityDetail.title
                ? orderParams.commodityDetail.title
                : "-"
            }}
          </div>
          <div class="numAndprice">
            <p class="num">
              x{{ orderParams.number ? orderParams.number : "-" }}
            </p>
            <p class="price">
              {{ $route.params.flag ? "" : "￥"
              }}{{
                orderParams.commodityDetail.user_price
                  ? orderParams.commodityDetail.user_price == -1
                    ? orderParams.commodityDetail.price
                    : orderParams.commodityDetail.user_price
                  : "-"
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="bottom_line"></div>
      <p class="payable">
        <span v-if="$route.params.flag">应付积分：</span
        ><span v-else>应付：</span>
        <span style="font-weight: bold"
          >{{ $route.params.flag ? "" : "￥" }}{{ totalMoney }}</span
        >
      </p>
    </div>
    <div class="bottom">
      <div
        class="total"
        style="font-size: 0.17rem; color: #94683e; line-height: 0.2rem"
      >
        <span style="font-size: 0.15rem; color: #343434">积分合计：</span>
        {{ $route.params.flag ? "" : "￥"
        }}<span style="font-weight: bold">{{ parseInt(totalMoney) }}</span>
        <span>{{
          totalMoney.toString().indexOf(".") != -1
            ? totalMoney
                .toString()
                .substring(totalMoney.toString().indexOf("."))
            : ""
        }}</span>
      </div>
      <van-button class="btn" @click="buyIt">{{
        $route.params.flag ? "确认兑换" : "确认购买"
      }}</van-button>
    </div>
  </div>
</template>

<script>
import { addressList, getMakeSureOrder, scoreBuy } from "@/api/home.js";
export default {
  data() {
    return {
      orderParams: {},
      totalMoney: "",
      address: {},
    };
  },
  created() {
    let backAddress = JSON.parse(sessionStorage.getItem("backAddress"));
    if (backAddress) {
      this.address = backAddress;
    } else {
      addressList({ default: 1 }).then((res) => {
        if (res.data.backdata.address.length > 0) {
          this.address = res.data.backdata.address[0];
        } else {
          this.$dialog
            .confirm({
              title: "请先设置地址",
              message: "您还没有设置默认地址，点击确定设置",
            })
            .then(() => {
              this.$router.push({ name: "收货地址" });
            })
            .catch(() => {
              this.$router.back();
            });
        }
      });
    }

    if (this.$route.params.number) {
      this.orderParams = this.$route.params;
      sessionStorage.setItem("orderParams", JSON.stringify(this.$route.params));
    } else {
      this.orderParams = JSON.parse(sessionStorage.getItem("orderParams"));
    }
    this.totalMoney =
      this.orderParams.number * this.orderParams.commodityDetail.user_price;
  },
  methods: {
    buyIt() {
      let loading = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      if (this.$route.params.flag) {
        scoreBuy({
          score_id: this.orderParams.commodityDetail.id,
          num: this.orderParams.number,
          add_id: this.address.id,
        })
          .then((res) => {
            loading.clear();
            this.$toast(res.data.msg);
            if (res.data.code == 0) {
              // this.$router.back()
              this.$router.push({ name: "兑换记录" });
            }
          })
          .catch((err) => {
            loading.clear();
          });
      } else {
        getMakeSureOrder({
          id: this.orderParams.commodityDetail.id,
          num: this.orderParams.number,
          add_id: this.address.id,
        })
          .then((res) => {
            loading.clear();
            if (res.data.code == 0) {
              this.$router.push({
                name: "在线支付",
                params: {
                  num: this.orderParams.number,
                  title: this.orderParams.commodityDetail.title,
                  totalMoney: this.totalMoney,
                  orderId: res.data.backdata.orderid,
                },
              });
            } else {
              this.$toast(res.data.msg);
            }
          })
          .catch((err) => {
            loading.clear();
          });
      }
    },
    toShippingAddress() {
      this.$router.replace({ name: "收货地址" });
    },
  },
};
</script>

<style lang="scss">
.makeSureTheOrder {
  padding: 0.15rem 0.15rem 0 0.15rem;
  margin: 0.49rem 0 0.6rem 0;
  // 地址栏
  .information {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 3.45rem;
    height: 0.9rem;
    padding: 0.12rem 0.15rem 0.15rem;
    margin-bottom: 0.11rem;
    background: url("../../assets/img/icon_adress_line@2x.png") no-repeat;
    background-position: bottom;
    background-size: contain;
    .peopleInformation {
      .address {
        width: 2.66rem;
        font-size: 0.14rem;
        font-weight: bold;
        color: #343434;
        line-height: 0.18rem;
        margin-bottom: 0.06rem;
      }
      .phoneAndName {
        font-size: 0.12rem;
        color: #343434;
      }
    }
  }
  // 购买的商品信息
  .commodity {
    width: 3.45rem;
    height: 2.15rem;
    background: #ffffff;
    border-radius: 0.08rem;
    padding: 0.16rem 0.15rem 0.22rem 0.15rem;
    margin-bottom: 0.1rem;
    h2 {
      font-size: 0.15rem;
      color: #343434;
      margin-bottom: 0.17rem;
    }
    .commodityInformation {
      width: 100%;
      display: flex;
      img {
        margin-right: 0.15rem;
      }
      .commodityInformation_right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 2.11rem;
        height: 0.88rem;
        padding: 0.02rem 0 0.05rem;
        .commodity_name {
          width: 2.11rem;
          font-size: 0.14rem;
          font-weight: bold;
          color: #343434;
          line-height: 20px;
        }
        .numAndprice {
          display: flex;
          justify-content: space-between;
          .num {
            font-size: 0.12rem;
            color: #9a9a9c;
            line-height: 0.2rem;
          }
          .price {
            font-size: 0.15rem;
            font-weight: bold;
            color: #343434;
            line-height: 0.2rem;
          }
        }
      }
    }
    .bottom_line {
      width: 100%;
      height: 0.01rem;
      background: #9a9a9c;
      margin: 0.19rem 0 0.18rem 0;
    }
    .payable {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      font-size: 0.15rem;
      color: #343434;
      line-height: 0.2rem;
    }
  }
  .bottom {
    width: 100%;
    height: 0.5rem;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    position: fixed;
    left: 0;
    bottom: 0;
    .total {
      display: flex;
      align-items: center;
      margin: 0 0 0 0.15rem;
    }
    .btn {
      width: 1.96rem;
      height: 0.5rem;
      background: linear-gradient(0deg, #d2ae7a 0%, #f0d8b2 100%);
      border: none;

      font-size: 0.16rem;
      font-weight: bold;
      color: #94683e;
      line-height: 0.2rem;
    }
  }
}
</style>
